import * as types from '../mutation-types'
import core from '@/js/core/core'
import Vue from 'vue'
import vueCookie from 'vue-cookie'
import EventBus from '@/vue/events/event-bus'
import moment from 'moment'
import {updateHightlightOdds} from '@/js/common/common'

// initial state
const state = {
    bettingFormToggle: false,
    bettingSelection: [],
    latestInfo: null,
    bettingMessage: null,
    mulpAllUpList: null,
    selectedAllUp: null,
    delayBetTimerId: null,
    allowRequestLatestInfo: true,
    betAmount: null,
    isMulpDayExceed: false,
    isBackgroundDelayBetting: false,
    currentBettingSelectionTemplate: false,
    delayBet: null,
    showDelAll: false,
    commonAmtSetting: false,
    commonAmt: null,
    possibleAmt: null,
    showHelp: false,
    tipsType: null,
    currentBetInfo: null,
    emptyBetAmt: false,
    isComboBet: false,
    combtAmt: [],
    combMaxInfo: false,
    selectedCombtBox: null,
    comboMax: window.comboMax,
    allowComboBet: window.allowComboBet,
    comboSuccessBetList: [],
    successBettingSelection: [],
    currentBetMarket: null,
    keepBettingSelection: [],
    comboErrBetList: [],
    errorBettingSelection: [],
    haveEmptyCombo: false,
    comboReachMaxBet: false,
    isShowChipMin: true,
    isShowChipMed: true,
    isShowChipBig: true,
    betMulpAmount: [],
    betMulpAmtFiltered: [],
    notSupportParlay: {
        show: false
    },
    prev_combobet: null,
    mulpMaxPayArr: [],
}

// getters
const getters = {
    bettingFormToggle: state => state.bettingFormToggle,
    bettingSelection: state =>  {
        if(localStorage.getItem('bts')) {
            var bts = JSON.parse(localStorage.getItem('bts'))
            if(bts.data!=''&&bts.data.length>0){
                state.currentBettingSelectionTemplate = bts.selection
                state.bettingSelection = bts.data
            }
        }
        return state.bettingSelection
    },
    latestInfo: state => state.latestInfo,
    bettingMessage: state => state.bettingMessage,
    mulpAllUpList: state => state.mulpAllUpList,
    selectedAllUp: state => state.selectedAllUp,
    betAmount: state => state.betAmount,
    currentBettingSelectionTemplate: state => state.currentBettingSelectionTemplate,
    delayBet: state => state.delayBet,
    showDelAll: state => state.showDelAll,
    commonAmtSetting: state => state.commonAmtSetting,
    commonAmt: state => state.commonAmt,
    possibleAmt: state => state.possibleAmt,
    showHelp: state => state.showHelp,
    tipsType: state => state.tipsType,
    currentBetInfo: state => state.currentBetInfo,
    emptyBetAmt: state => state.emptyBetAmt,
    isComboBet: state => state.isComboBet,
    combtAmt: state => state.combtAmt,
    combMaxInfo: state => state.combMaxInfo,
    selectedCombtBox: state => state.selectedCombtBox,
    comboMax: state => state.comboMax,
    allowComboBet: state => state.allowComboBet,
    comboSuccessBetList: state => state.comboSuccessBetList,
    successBettingSelection: state => state.successBettingSelection,
    currentBetMarket: state => state.currentBetMarket,
    keepBettingSelection: state => state.keepBettingSelection,
    comboErrBetList: state => state.comboErrBetList,
    errorBettingSelection: state => state.errorBettingSelection,
    haveEmptyCombo: state => state.haveEmptyCombo,
    comboReachMaxBet: state => state.comboReachMaxBet,
    isShowChipMin: state => state.isShowChipMin,
    isShowChipMed: state => state.isShowChipMed,
    isShowChipBig: state => state.isShowChipBig,
    betMulpAmount: state => state.betMulpAmount,
    betMulpAmtFiltered: state => state.betMulpAmtFiltered,
    notSupportParlay: state => state.notSupportParlay,
    prev_combobet: state => state.prev_combobet,
    mulpMaxPayArr: state => state.mulpMaxPayArr,
}

// actions
const actions = {
    finishBet(context, payload) {
        this.commit('BETTING_MESSAGE', null)
        this.commit('LATEST_INFO', null)
        this.commit('BETTING_SELECTION', [])
    },
    confirmBet(context, payload) {
        if (this.getters.requestAllow == false) {
            return
        }
        // if (this.getters.arr_selectedTemplate.subTemplateId != 2) {
        //     EventBus.$emit('clearBetFormTimer')
        // }
        var STORE = this
        var dual = ''
        var betData = {}

        var betSelect = STORE.getters.bettingSelection
        var amt = _.cloneDeep(STORE.getters.combtAmt)
        
        if(STORE.getters.errorBettingSelection && (STORE.getters.errorBettingSelection).length > 0){
            STORE.commit('BETTING_SELECTION', [])
            betSelect = STORE.getters.errorBettingSelection
        }
        
        _.forEach(this.getters.latestInfo.betting, function (value, key) {
            if (!_.isUndefined(betSelect[key]) && !_.isUndefined(betSelect[key]['subMatchKey']) && betSelect[key]['subMatchKey'] == 0) {
                dual = 'a'
            } else if (!_.isUndefined(betSelect[key]) && !_.isUndefined(betSelect[key]['subMatchKey']) && betSelect[key]['subMatchKey'] == 1) {
                dual = 'b'
            } else if (!_.isUndefined(betSelect[key]) && !_.isUndefined(betSelect[key]['subMatchKey']) && betSelect[key]['subMatchKey'] == 2) {
                dual = 'c'
            } else if (!_.isUndefined(betSelect[key]) && !_.isUndefined(betSelect[key]['subMatchKey']) && betSelect[key]['subMatchKey'] == 3) {
                dual = 'd'
            } else if (!_.isUndefined(betSelect[key]) && !_.isUndefined(betSelect[key]['subMatchKey']) && betSelect[key]['subMatchKey'] == 4) {
                dual = 'e'
            } else {
                return
            }
            betData[key] = {}
            betData[key]['sprtid'] = value.sprtid
            betData[key]['eveid'] = value['eveid']
            betData[key]['plyType'] = value.plyType
            betData[key]['taid'] = value['taid']
            betData[key]['tbid'] = value['tbid']
            betData[key]['tbetid'] = value.tbetid
            betData[key]['betType'] = value.betType
            betData[key]['dual'] = dual
            betData[key]['tbet'] = value.tbet
            betData[key]['rbscoa'] = (value.rbscoa) ? value.rbscoa : 0
            betData[key]['rbscob'] = (value.rbscob) ? value.rbscob : 0
            betData[key]['fav'] = (value.fav) ? value.fav : 0
            betData[key]['odd'] = value.odd
            betData[key]['hdp'] = value.hdp
            betData[key]['rca'] = (value.rca) ? value.rca : 0
            betData[key]['rcb'] = (value.rcb) ? value.rcb : 0
            if(STORE.getters.isComboBet){
                betData[key]['minMax'] = value.minMax
            }

            if(STORE.getters.errorBettingSelection && (STORE.getters.errorBettingSelection).length > 0){
                STORE.commit('BETTING_SELECTION', {
                    'event': betSelect[key].event,
                    'bettype': betSelect[key].bettype,
                    'team': betSelect[key].team,
                    'playtype': betSelect[key].playtype,
                    'sportid': betSelect[key].sportid,
                    'subMatchKey': betSelect[key].subMatchKey,
                    'uniqueId': betSelect[key].uniqueId,
                    'marketToggle': betSelect[key].marketToggle,
                })
                STORE.commit('COMBET_AMT', amt)
            }
        });
        this.commit('REQUEST_ALLOW', false)
        // if (betData[0]['sprtid'] != 1 && this.getters.int_marketToggle == 3) {
        if(this.getters.delayBet > 0) {    
            this.dispatch('ajaxInitBet', {
                payload: payload,
                data: betData
            })
        } else {
            if(this.getters.isComboBet){
                this.dispatch('ajaxComboBet', {
                    payload: payload,
                    data: betData
                })
            }else if(this.getters.isParlay){
                this.dispatch('ajaxMulpComboBet', {
                    payload: payload,
                    data: betData
                })
            }else{
                this.dispatch('ajaxConfirmBet', {
                    payload: payload,
                    data: betData
                })
            }
        }
    },
    ajaxInitBet(context, payload) {
        let STORE = this
        core.$ajax({
            method: 'post',
            url: window._baseUrl + '/sport-betting/init-bet',
            data: {
                enableLoading: false
            }
        }).done(((res) => {
            var delayTimer = parseInt(res.SYSTEM_DATA.DelayBet) * 1000

            state.delayBetTimerId = setTimeout((function () {
                if(this.getters.isComboBet){
                    this.dispatch('ajaxComboBet', {
                        payload: payload.payload,
                        data: payload.data,
                        isInitBet: true    
                    })
                } else if(this.getters.isParlay){
                    this.dispatch('ajaxMulpComboBet', {
                        payload: payload.payload,
                        data: payload.data,
                        isInitBet: true    
                    })
                } else{
                    this.dispatch('ajaxConfirmBet', {
                        payload: payload.payload,
                        data: payload.data,
                        isInitBet: true
                    })
                }
            }).bind(this), delayTimer);

        }).bind(this)).catch((errRes) => {
            console.log(errRes)
        })
    },
    ajaxConfirmBet(context, payload) {
        // if (this.getters.arr_selectedTemplate.subTemplateId == 2) {
        //     EventBus.$emit('clearMulpBetFormTimer')
        // }
        let STORE = this
        var payloadData = payload

        if(!state.isBackgroundDelayBetting) {
            this.commit('BETTING_MESSAGE', {
                isError: false
            }) 
        }

        var odTyp = this.getters.account.oddsType
        var isMulp = 0
        var allUp = ''
        if (this.getters.isParlay) { //state.currentBettingSelectionTemplate == 2
            odTyp = odTyp!='am'? this.getters.oddTypesList.EU.key : odTyp
            isMulp = 1
            allUp = this.getters.selectedAllUp
        }

        if(payload.payload.market&&payload.payload.market!=''){
            this.commit('CURRENT_BET_MARKET', payload.payload.market)
        }

        // pass bet info (index) that is joining promotion
        if(this.getters.promotionFlag && !this.getters.promotionBetWithoutJoin && !isMulp && !this.getters.promotionBetStatus){
            var promotionBetIndexArr = this.getters.promotionBetIndex
        }

        core.$ajax({
            data: {
                betting: payload.data,
                oddsType: odTyp,
                isMulp: isMulp,
                amount: payload.payload.betAmount!=undefined?payload.payload.betAmount:this.getters.combtAmt,
                betterOd: this.getters.account.autoAccBetterOdd,
                allUp: allUp,
                market: payload.payload.market&&payload.payload.market!=''?payload.payload.market:this.getters.int_marketToggle,
                enableLoading: false,
                promotionBetIndexArr: promotionBetIndexArr,
                token: token.arr_2,
            },
            method: 'post',
            url: window._baseUrl + '/sport-betting/confirm-bet', 
        }).done(((res) => {
            //TODO : valdiation handler
            STORE.commit('REQUEST_ALLOW', true)
            STORE.commit('IS_PROCESS_BET', false)
            state.allowRequestLatestInfo = true

            if(payloadData.isInitBet && state.delayBetTimerId) {
                state.delayBetTimerId = null;
            }
            if(state.isBackgroundDelayBetting) {
                state.isBackgroundDelayBetting = false;
                return;
            }
            if (res.SYSTEM_DATA.status == 'FAIL') {
                this.commit('BETTING_MESSAGE', {
                    isError: true,
                    data: res.SYSTEM_DATA
                })
                if (res.SYSTEM_DATA.code.indexOf('4022') >= 0) {
                    alert(res.SYSTEM_DATA.message + '(' + res.SYSTEM_DATA.code + ')');
                    this.dispatch('logoutAccount')
                }
                this.commit('LATEST_INFO', null)
                EventBus.$emit('clearBetFormTimer', {
                    clearBetAmount: true
                })
                // EventBus.$emit('resetBetFormTimer')

            } else if (res.SYSTEM_DATA.WagerID) {
                this.commit('LATEST_INFO', null)
                this.commit('CURRENT_BETINFO', null)
                // this.commit('BETTINGFORM_TOGGLE', false)
                this.commit('BETTING_MESSAGE', {
                    isSuccess: true,
                    data: res.SYSTEM_DATA
                })
                this.dispatch('getSportCCL', {
                    token: token.arr_7,
                    enableLoading: false,
                })
                /*
                this.dispatch('getOpenBet', {
                    wgrTyp: 'openBet',
                    isCount: true,
                    sprtId: '99',
                    enableLoading: loading,
                    token: token.arr_1,
                })*/
                
               // EventBus.$emit('refreshOpenBetCount')
                EventBus.$emit('clearBetFormTimer')
                if ((this.getters.arr_selectedTemplate.int_marketToggle == '3' || payload.payload.market == '3') && 
                    this.getters.arr_selectedTemplate.sportId == this.getters.sportBettypeList.N1.sprtId) {
                    EventBus.$emit('validatePendingWager', res)
                }
                // set success status if joined and bet promotion successful
                if(this.getters.promotionFlag && !this.getters.promotionBetStatus) {
                    this.commit('PROMO_SHOW_JOIN_SUCCESS', res.SYSTEM_DATA.promotionBetStatus!=undefined? res.SYSTEM_DATA.promotionBetStatus: false)
                    this.commit('PROMO_BET_STATUS', res.SYSTEM_DATA.promotionBetStatus!=undefined? res.SYSTEM_DATA.promotionBetStatus: false)
                }
            } else {
                this.commit('BETTING_MESSAGE', {
                    isError: true,
                    data: res.SYSTEM_DATA.error
                })
                if (res.SYSTEM_DATA.error.code.indexOf('4002') >= 0) {
                    this.dispatch('getLatestInfo', {
                        token: token.arr_5
                    });
                } else {
                    this.commit('LATEST_INFO', res.SYSTEM_DATA)
                }
                
                EventBus.$emit('refreshBetFormTimer')
            }
        }).bind(this)).catch((errRes) => {
            console.log(errRes)
        })
    },
    ajaxComboBet(context, payload) {
        let STORE = this
        var payloadData = payload

        if(!state.isBackgroundDelayBetting) {
            this.commit('BETTING_MESSAGE', {
                isError: false
            }) 
        }

        var odTyp = this.getters.account.oddsType
        var isMulp = 0
        var allUp = ''
        if (this.getters.isParlay) { //state.currentBettingSelectionTemplate == 2
            odTyp = odTyp!='am'? this.getters.oddTypesList.EU.key : odTyp
            isMulp = 1
            allUp = this.getters.selectedAllUp
        }

        if(payload.payload.market&&payload.payload.market!=''){
            this.commit('CURRENT_BET_MARKET', payload.payload.market)
        }

        // pass bet info (index) that is joining promotion
        if(this.getters.promotionFlag && !this.getters.promotionBetWithoutJoin && !isMulp && !this.getters.promotionBetStatus){
            var promotionBetIndexArr = this.getters.promotionBetIndex
        }
        
        core.$ajax({
            data: {
                betting: payload.data,
                oddsType: odTyp,
                isMulp: isMulp,
                amount: this.getters.combtAmt,
                betterOd: this.getters.account.autoAccBetterOdd,
                allUp: allUp,
                market: payload.payload.market&&payload.payload.market!=''?payload.payload.market:this.getters.int_marketToggle,
                enableLoading: false,
                token: token.arr_2,
                isCombo: this.getters.isComboBet ? 1 : 0,
                promotionBetIndexArr: promotionBetIndexArr,
            },
            method: 'post',
            url: window._baseUrl + '/sport-betting/confirm-combo-bet', 
        }).done(((res) => {
            //TODO : valdiation handler
            let data = JSON.parse(res)
            let records = data.SYSTEM_DATA.betting
            let successArr = []
            let errorArr = []
            let successBetArr = []
            let errBetArr =[]
            let errCode = ['4003-N', '4010-N', 'N-4000-N']

            STORE.commit('REQUEST_ALLOW', true)
            STORE.commit('IS_PROCESS_BET', false)
            state.allowRequestLatestInfo = true

            if(payloadData.isInitBet && state.delayBetTimerId) {
                state.delayBetTimerId = null;
            }
            if(state.isBackgroundDelayBetting) {
                state.isBackgroundDelayBetting = false;
                return;
            }
            
            if(records && Object.keys(records).length>0){
                _.forEach(records, function(rec, rekey){
                    if(rec.error && rec.error != ''){
                        if(!_.isUndefined(rec.error.code)){
                            if(!_.includes(errCode, rec.error.code)){
                                STORE.commit('BETTING_MESSAGE', {
                                    isError: true,
                                    data: records
                                })
                            }
                        } else {
                            STORE.commit('BETTING_MESSAGE', {
                                isError: true,
                                data: records
                            })
                        }
                        if (rec.error.code.indexOf('4002') >= 0) {
                            STORE.dispatch('getLatestInfo', {
                                token: token.arr_5
                            });
                        } else {
                            STORE.commit('LATEST_INFO', data.SYSTEM_DATA)
                        }
                        
                        EventBus.$emit('refreshBetFormTimer')
                    }
                })
                var wgSuccess = _.findIndex(records, function(record) {
                    return record.WagerID !== undefined;
                });
                if(!STORE.getters.bettingMessage.isError || wgSuccess>-1){
                    errorArr = _.pickBy(records, function(val, key){
                        // if(_.includes(errCode, val.error.code)){
                        if(val.error && val.error!=''){
                            errBetArr.push(STORE.getters.bettingSelection[key])
                        }
                        // return _.includes(errCode, val.error.code)
                        return val.error && val.error!=''
                    })
                    
                    successArr = _.pickBy(records, function(val, key){
                        if(val.WagerID){
                            successBetArr.push(STORE.getters.bettingSelection[key])
                        }
                        return val.WagerID
                    })
                    
                    // if(STORE.getters.comboSuccessBetList.length!=Object.keys(successArr).length){
                    //     STORE.commit('COMB_SUCCESS_BET_LIST', successArr)
                    //     STORE.commit('SUCCESS_BETTING_SELECTION', successBetArr)
                    // }

                    // if(STORE.getters.comboErrBetList.length!=Object.keys(errorArr).length){
                    //     STORE.commit('COMB_ERR_BET_LIST', errorArr)
                    //     STORE.commit('ERR_BETTING_SELECTION', errBetArr)
                    // }
                    
                    // successBetArr = _.filter(successArr, function(val, key){
                    //     return STORE.getters.bettingSelection[key]
                    // })

                    if(Object.keys(errorArr).length>0){
                        let errAmt = STORE.getters.combtAmt.flatMap((x) => x=0)
                        STORE.commit('COMBET_AMT', errAmt)
                    }

                    STORE.commit('BETTING_MESSAGE', {
                        data: records,
                        accCL: data.SYSTEM_DATA.accCcl,
                        isSuccess: true,
                    })
                    this.commit('CURRENT_BETINFO', data.SYSTEM_DATA)

                    this.dispatch('getSportCCL', {
                        token: token.arr_7,
                        enableLoading: false,
                    })

                    EventBus.$emit('clearBetFormTimer', {
                        clearBetAmount: true
                    })

                    if ((this.getters.arr_selectedTemplate.int_marketToggle == '3' || payload.payload.market == '3') && 
                        this.getters.arr_selectedTemplate.sportId == this.getters.sportBettypeList.N1.sprtId) {
                        EventBus.$emit('validateComboPendingWager', data)
                    }

                    // set success status if joined and bet promotion successful
                    if(this.getters.promotionFlag && !this.getters.promotionBetStatus) {
                        for(const value of this.getters.promotionBetIndex) {
                            this.commit('PROMO_SHOW_JOIN_SUCCESS', data.SYSTEM_DATA.betting[value].promotionBetStatus != undefined? data.SYSTEM_DATA.betting[value].promotionBetStatus:false)
                            this.commit('PROMO_BET_STATUS', data.SYSTEM_DATA.betting[value].promotionBetStatus != undefined? data.SYSTEM_DATA.betting[value].promotionBetStatus:false)
                            if(data.SYSTEM_DATA.betting[value].promotionBetStatus != undefined && data.SYSTEM_DATA.betting[value].promotionBetStatus == true){
                              break
                            }
                        }
                    }
                    
                    STORE.commit('COMB_SUCCESS_BET_LIST', successArr)
                    STORE.commit('SUCCESS_BETTING_SELECTION', successBetArr)
        
                    STORE.commit('COMB_ERR_BET_LIST', errorArr)
                    STORE.commit('ERR_BETTING_SELECTION', errBetArr)
                }

                // STORE.$nextTick(()=>{
                //     STORE.commit('BETTING_MESSAGE', {
                //         data: records,
                //         accCL: data.SYSTEM_DATA.accCcl,
                //         isSuccess: true,
                //     })
                // })
            }

            // if (res.SYSTEM_DATA.status == 'FAIL') {
            //     this.commit('BETTING_MESSAGE', {
            //         isError: true,
            //         data: res.SYSTEM_DATA
            //     })
            //     if (res.SYSTEM_DATA.code.indexOf('4022') >= 0) {
            //         alert(res.SYSTEM_DATA.message + '(' + res.SYSTEM_DATA.code + ')');
            //         this.dispatch('logoutAccount')
            //     }
            //     this.commit('LATEST_INFO', null)
            //     EventBus.$emit('clearBetFormTimer', {
            //         clearBetAmount: true
            //     })
            //     // EventBus.$emit('resetBetFormTimer')

            // } else if (res.SYSTEM_DATA.WagerID) {
            //     this.commit('LATEST_INFO', null)
            //     this.commit('CURRENT_BETINFO', null)
            //     // this.commit('BETTINGFORM_TOGGLE', false)
            //     this.commit('BETTING_MESSAGE', {
            //         isSuccess: true,
            //         data: res.SYSTEM_DATA
            //     })
            //     this.dispatch('getSportCCL', {
            //         token: token.arr_7,
            //         enableLoading: false,
            //     })
            //     /*
            //     this.dispatch('getOpenBet', {
            //         wgrTyp: 'openBet',
            //         isCount: true,
            //         sprtId: '99',
            //         enableLoading: loading,
            //         token: token.arr_1,
            //     })*/
                
            //    // EventBus.$emit('refreshOpenBetCount')
            //     EventBus.$emit('clearBetFormTimer', {
            //         clearBetAmount: true
            //     })
            //     if (this.getters.arr_selectedTemplate.int_marketToggle == '3' && 
            //         this.getters.arr_selectedTemplate.sportId == this.getters.sportBettypeList.N1.sprtId) {
            //         EventBus.$emit('validatePendingWager', res)
            //     }
            // } else {
            //     this.commit('BETTING_MESSAGE', {
            //         isError: true,
            //         data: res.SYSTEM_DATA.error
            //     })
            //     if (res.SYSTEM_DATA.error.code.indexOf('4002') >= 0) {
            //         this.dispatch('getLatestInfo', {
            //             token: token.arr_5
            //         });
            //     } else {
            //         this.commit('LATEST_INFO', res.SYSTEM_DATA)
            //     }
                
            //     EventBus.$emit('refreshBetFormTimer')
            // }
        }).bind(this)).catch((errRes) => {
            console.log(errRes)
        })
    },
    ajaxMulpComboBet(context, payload) {
        let STORE = this
        var payloadData = payload

        if(!state.isBackgroundDelayBetting) {
            this.commit('BETTING_MESSAGE', {
                isError: false
            }) 
        }

        var odTyp = this.getters.account.oddsType!='am'? this.getters.oddTypesList.EU.key : this.getters.account.oddsType
        var mrkt = this.getters.int_marketToggle
        if(payload.payload.market&&payload.payload.market!=''){
            mrkt = payload.payload.market
            this.commit('CURRENT_BET_MARKET', payload.payload.market)
        }

        var betAmt = payload.payload.betAmount!=undefined?payload.payload.betAmount:this.getters.betMulpAmtFiltered
        var amountArr = []
        var allUpArr = []
        _.forEach(betAmt, function(arr, key) {
            amountArr[key] = arr.amount
            allUpArr[key] = arr.allUpKey
        });

        var dt = {
            betting: payload.data,
            oddsType: odTyp,
            isMulp: this.getters.isParlay? 1:0,
            isCombo: 0,
            amount: amountArr,
            betterOd: this.getters.account.autoAccBetterOdd,
            allUp: allUpArr,
            market: mrkt,
            enableLoading: false,
            token: token.arr_2,
            minMax: this.getters.latestInfo.minMax,
        }

        core.$ajax({
            data: dt,
            method: 'post',
            url: window._baseUrl + '/sport-betting/confirm-mulp-combo-bet', 
        }).done(((res) => {
            //TODO : valdiation handler
            let ret = JSON.parse(res)
            let data = ret.SYSTEM_DATA.mulpRes
            STORE.commit('REQUEST_ALLOW', true)
            STORE.commit('IS_PROCESS_BET', false)
            state.allowRequestLatestInfo = true

            if(payloadData.isInitBet && state.delayBetTimerId) {
                state.delayBetTimerId = null;
            }
            if(state.isBackgroundDelayBetting) {
                state.isBackgroundDelayBetting = false;
                return;
            }

            var wgSuccess = _.findIndex(ret.SYSTEM_DATA.mulpRes, function(record) {
                return record.WagerID !== undefined;
            });
            var wgError = _.findIndex(ret.SYSTEM_DATA.mulpRes, function(record) {
                return record.error !== '';
            });
            
            this.dispatch('getSportCCL', {
                token: token.arr_7,
                enableLoading: false,
            })
            EventBus.$emit('clearBetFormTimer', {
                clearBetAmount: true
            })

            if(wgSuccess>-1){
                // this.commit('LATEST_INFO', null)
                // this.commit('CURRENT_BETINFO', null)
                this.commit('BETTING_MESSAGE', {
                    isSuccess: true,
                    data: ret.SYSTEM_DATA
                })
                this.commit("BETMULP_AMOUNT", []);
                EventBus.$emit('countTotalStakePayout', ret.SYSTEM_DATA)
                EventBus.$emit('validateParlayPendingWager', ret)
            } else {
                // STORE.commit('LATEST_INFO', ret.SYSTEM_DATA)
                STORE.dispatch('getLatestInfo', {
                    token: token.arr_5,
                    callback: res => {
                        var code = 'n/a'
                        var message = STORE.getters.arr_lang.betForm['BET_FORM.LBL_REJECT_BET']
                        // var errObj = { error:true, msg:message }
                        if(wgError>-1){
                            var err = ret.SYSTEM_DATA.mulpRes[wgError].error
                            message = _.isUndefined(err.message)? message : err.message
                            code = _.isUndefined(err.code)? message : err.code
                            // errObj.msg = message
                        }
                        STORE.commit('BETTING_MESSAGE', {
                            isError: true,
                            data: { code: code, message: message }
                        })
                    }
                });
            }

        }).bind(this)).catch((errRes) => {
            console.log(errRes)
        })
    },
    preBetForm(context, payload) {
        if (parseInt(this.getters.account.currCL) <= 0) {
            this.commit('BETTING_MESSAGE', {
                isError: true,
                data: {
                    code: 'S-4015-A',
                    message: this.getters.arr_lang.betForm['BET_FORM.ERR_MSG_INSUFFICIENT_AMOUNT']

                }
            })
	        this.commit('BETTINGFORM_TOGGLE', true)
            EventBus.$emit('resetBetFormTimer')
            return;
        }
        
        this.commit('REQUEST_ALLOW', true)
        this.commit('BETTING_MESSAGE', null)
        this.commit('LATEST_INFO', null)
        if(state.delayBetTimerId) {
            state.isBackgroundDelayBetting = true
        }
        
        if(state.currentBettingSelectionTemplate && (state.currentBettingSelectionTemplate != this.getters.arr_selectedTemplate.subTemplateId)) {
            if(!this.getters.isComboBet && !this.getters.isParlay){
                this.commit('BETTING_SELECTION', [])
            }
        }
        state.currentBettingSelectionTemplate = this.getters.arr_selectedTemplate.subTemplateId
        var subMatchKey = (payload.subMatchKey) ? payload.subMatchKey : '0'
        if (this.getters.isParlay) { //state.currentBettingSelectionTemplate == 2
            //MULP
            let vue = this
            let removeArr = []
            if(this.getters.bettingSelection && Object.keys(this.getters.bettingSelection).length > 0) {
                $.each(this.getters.bettingSelection,function(id,value){
                    if(value.sportid != payload.event.sptid){
                        removeArr.push(id)
                    }
                });
                removeArr = removeArr.sort().reverse()
                $.each(removeArr,function(id,value){
                    vue.commit('BETTING_SELECTION', {
                        isRemove: true,
                        removeIndex: value
                    })
                });
            }

            if(this.getters.bettingSelection && Object.keys(this.getters.bettingSelection).length<this.getters.comboMax){
                var eventDate = ''
                if(payload.event.dt){
                    eventDate = new moment(payload.event.dt).locale('en').format("YYYY-MM-DD")
                }
                var filterDateIndex = _.indexOf(this.getters.arr_earlyParlayDateList, eventDate)
                var marketToggle = filterDateIndex === 0 ? 1 : 2
                this.commit('BETTING_SELECTION', {
                    'event': payload.event,
                    'bettype': payload.bettype,
                    'team': payload.team,
                    'playtype': payload.playtype,
                    'sportid': payload.event.sptid,
                    'subMatchKey': subMatchKey,
                    'uniqueId': payload.uniqueId ? payload.uniqueId : '',
                    'marketToggle': marketToggle,
                })
                if(this.getters.bettingSelection.length>0){
                    this.dispatch('getLatestInfo', {
                        token: token.arr_2
                    })
                }
            }else{
                this.commit('COMB_MAX', true)
                setTimeout((function(){
                    this.commit('COMB_MAX', false)
                }).bind(this) ,1000)
            }

            if(removeArr.length > 0 && this.getters.bettingSelection && Object.keys(this.getters.bettingSelection).length == 1) {
                this.commit('BETTINGFORM_TOGGLE', true)
            }
        }else if (this.getters.isComboBet) { //state.currentBettingSelectionTemplate == 2
            //combo bet
            if(this.getters.bettingSelection && Object.keys(this.getters.bettingSelection).length<this.getters.comboMax){
                this.commit('BETTING_SELECTION', {
                    'event': payload.event,
                    'bettype': payload.bettype,
                    'team': payload.team,
                    'playtype': payload.playtype,
                    'sportid': payload.event.sptid,
                    'subMatchKey': subMatchKey,
                    'uniqueId': payload.uniqueId ? payload.uniqueId : '',
                    'marketToggle': marketToggle,
                })
                if(this.getters.bettingSelection.length>0){
                    this.dispatch('getLatestInfo', {
                        token: token.arr_2
                    })
                }
            }else{
                this.commit('COMB_MAX', true)
                setTimeout((function(){
                    this.commit('COMB_MAX', false)
                }).bind(this) ,1000)
            }
        } else if (state.currentBettingSelectionTemplate == 3) {
            //OTR
            
            this.commit('BETTINGFORM_TOGGLE', true)
            this.commit('BETTING_SELECTION', {
                'event': payload.event,
                'eveid': payload.eveid,
                'bettype': payload.bettype,
                'team': payload.team,
                'playtype': payload.playtype,
                'sportid': payload.event[0]['sptid'],
                'subMatchKey': subMatchKey,
                'uniqueId': payload.uniqueId ? payload.uniqueId : '',
                'marketToggle': payload.marketToggle,
            })
            // this.dispatch('getLatestInfo');
            EventBus.$emit('resetBetFormTimer')
        } else {
            this.commit('BETTINGFORM_TOGGLE', true)
            this.commit('BETTING_SELECTION', {
                'event': payload.event,
                'bettype': payload.bettype,
                'team': payload.team,
                'playtype': payload.playtype,
                'sportid': payload.event.sptid,
                'subMatchKey': subMatchKey,
                'uniqueId': payload.uniqueId ? payload.uniqueId : '',
                'marketToggle': payload.marketToggle,
            })
            // this.dispatch('getLatestInfo');
            EventBus.$emit('resetBetFormTimer')
        }
    },
    getLatestInfo(context, payload) {
        var token_val = payload.token
        if (state.allowRequestLatestInfo == false) {
            return
        }
        if (this.getters.requestAllow == false) {
            return
        }
        state.allowRequestLatestInfo = false
        var betData = {}
        var dual = ''
        var team = ''
        var STORE = this
        var selectedMarket = ''

        var betSelect = STORE.getters.bettingSelection
        
        if(STORE.getters.keepBettingSelection && (STORE.getters.keepBettingSelection).length > 0){
            betSelect = STORE.getters.keepBettingSelection
        }

        if(STORE.getters.errorBettingSelection && (STORE.getters.errorBettingSelection).length > 0){
            betSelect = STORE.getters.errorBettingSelection
        }
        
        _.forEach(betSelect, function (value, key) {
            betData[key] = {}
            if (betSelect[key]['subMatchKey'] == 0) {
                dual = 'a'
            } else if (betSelect[key]['subMatchKey'] == 1) {
                dual = 'b'
            } else if (betSelect[key]['subMatchKey'] == 2) {
                dual = 'c'
            } else if (betSelect[key]['subMatchKey'] == 3) {
                dual = 'd'
            } else if (betSelect[key]['subMatchKey'] == 4) {
                dual = 'e'
            } else {
                return
            }
            if (value.team == 'h') {
                team = 'a'
            } else if (value.team == 'a' && (value.bettype == '4' || value.bettype == '11' || value.bettype == '12' || value.bettype == '13' || value.bettype == '36' || value.bettype == '37' || value.bettype == '38' || value.bettype == '39' || value.bettype == '40' || value.bettype == '41' || value.bettype == '42' || value.bettype == '43' || value.bettype == '44' || value.bettype == '45' || value.bettype == '34' || value.bettype == '35' || value.bettype == '21' || value.bettype == '27' || value.bettype == '28' || value.bettype == '29' || value.bettype == '30' || value.bettype == '31' || value.bettype == '32' || value.bettype == '33' || value.bettype == '76' || value.bettype == '79')) {
                team = 'b'
            } else {
                team = value.team
            }
            betData[key]['sprtid'] = (STORE.getters.currentBettingSelectionTemplate == 3) ? value.sportid : value.event.sptid
            betData[key]['eveid'] = (STORE.getters.currentBettingSelectionTemplate == 3) ? value.eveid : value.event['eveid']
            betData[key]['plyType'] = value.playtype
            betData[key]['taid'] = value.event['taid']
            betData[key]['tbid'] = value.event['tbid']
            betData[key]['tbetid'] = (STORE.getters.currentBettingSelectionTemplate == 3) ? team : value.event['t' + team + 'id']
            betData[key]['betType'] = value.bettype
            betData[key]['dual'] = (STORE.getters.currentBettingSelectionTemplate == 3) ? 'a' : dual
            betData[key]['tbet'] = team
            if(value.rbstatus&&value.rbstatus==1){
                selectedMarket = 3
            }
        });

        var odTyp = this.getters.account.oddsType
        var isMulp = 0
        if (this.getters.isParlay) { //state.currentBettingSelectionTemplate == 2
            odTyp = odTyp!='am'? this.getters.oddTypesList.EU.key : odTyp
            isMulp = 1
        }
        
        core.$ajax({
            data: {
                betting: betData,
                oddsType: odTyp,
                isMulp: isMulp,
                enableLoading: false,
                market: selectedMarket!='' ? selectedMarket : this.getters.int_marketToggle,
                token: token_val,
                isCombo: this.getters.isComboBet ? 1 : 0,
            },
            method: 'post',
            url: window._baseUrl + '/sport-betting/latest-info',
        }).done(((res) => {
            let vue = this
            if (typeof res.SYSTEM_DATA.DelayBet !== 'undefined') {
                state.delayBet = res.SYSTEM_DATA.DelayBet
            }
            if (this.getters.requestAllow == false) {
                return
            }
            state.allowRequestLatestInfo = true

            // check if show parlay button 
            if(this.getters.isParlay){
                if(this.getters.arr_selectedTemplate.templateId!=21){
                    EventBus.$emit('setHasParlay', true)
                }
            } else if(res.SYSTEM_DATA.betting && this.getters.arr_selectedTemplate.templateId!=21){
                if(this.getters.isComboBet){
                    _.forEach(res.SYSTEM_DATA.betting, function(arr, key) {
                        var eid = _.findIndex(vue.getters.sortedEvents, (e) => {
                            return e.eveid == arr.eveid;
                        })
                        if(eid>-1){
                            var event = vue.getters.sortedEvents[eid]
                            if(event.sptid == '1') {
                                EventBus.$emit('setHasParlay', true)
                                if(!window.allowRbParlay && event.rbinfo && event.rbstatus=='1'){
                                    EventBus.$emit('setHasParlay', false)
                                    return false
                                }
                            } else {
                                if(event.sptid=='2' && event.lgeflag=='0' && !event.rbinfo && event.rbstatus!='1'){
                                    EventBus.$emit('setHasParlay', true)
                                } else {
                                    EventBus.$emit('setHasParlay', false)
                                    return false
                                }
                            }
                        } else {
                            EventBus.$emit('setHasParlay', false)
                        }
                    });
                } else {
                    // single bet and check has parlay
                    var eventId = res.SYSTEM_DATA.betting[0].eveid
                    var eid = _.findIndex(vue.getters.sortedEvents, (e) => {
                        return e.eveid == eventId;
                    })
                    if(eid>-1){
                        var event = this.getters.sortedEvents[eid]
                        if(event.sptid == '1') {
                            EventBus.$emit('setHasParlay', true)
                            if(!window.allowRbParlay && event.rbinfo && event.rbstatus=='1'){
                                EventBus.$emit('setHasParlay', false)
                            }
                        } else {
                            if(event.sptid=='2' && event.lgeflag=='0' && !event.rbinfo && event.rbstatus!='1'){
                                EventBus.$emit('setHasParlay', true)
                            } else {
                                EventBus.$emit('setHasParlay', false)
                            }
                        }
                    } else {
                        EventBus.$emit('setHasParlay', false)
                    }
                }
            } 

            var firstOccurrencesEvent = {};
            var duplicateEventIndexes = [];
            var earlyEventIndexes = [];
            var rbEventExist = false;
            var hasEarly = false;
            var crossNotAllow = false;
            var allowRBCross = false;
            var earlyMoreThanOneDay = false;
            var removeArr = [];

            if (res.SYSTEM_DATA.status == 'FAIL') {
                // remove bet that is not valid for parlay and show msg when second choice
                if(!this.getters.bettingFormToggle && this.getters.isParlay){ 
                    var parlay_unsupport_toggle = false
                    if(this.getters.bettingSelection.length>0){
                        $.each(res.SYSTEM_DATA.betting,function(id,value){
                            if(value.error != undefined && value.error != ''){
                                removeArr.push(id)
                                if(value.error.code.indexOf('4000-N1') > -1 || value.error.code.indexOf('4031') > -1) {
                                    parlay_unsupport_toggle = true
                                }
                            }
                        });

                        if(removeArr.includes(res.SYSTEM_DATA.betting.length-1)) {
                            this.commit('NOT_SUPPORT_PARLAY', {
                                show: true,
                                msg: parlay_unsupport_toggle? this.getters.arr_lang.betForm['BET_FORM.PARLAY_UNSUPPORTED']:this.getters.arr_lang.betForm['BET_FORM.INVALID']
                            })
                            setTimeout(function(){
                                vue.commit('NOT_SUPPORT_PARLAY', {reset:true})
                            },1500)
                        }

                        removeArr = removeArr.sort().reverse()
                        $.each(removeArr,function(id,value){
                            vue.commit('BETTING_SELECTION', {
                                isRemove: true,
                                removeIndex: value
                            })
                        });

                        if(this.getters.isParlay && this.getters.currentTab != '4' && this.getters.bettingSelection.length == 0) {
                            this.commit('CURRENT_BETINFO', null)
                            this.commit('IS_PARLAY', false)
                        }
                    }
                } else {
                    this.commit('BETTING_MESSAGE', {
                        isError: true,
                        data: res.SYSTEM_DATA
                    })
                    this.commit('LATEST_INFO', null)
                    if(res.SYSTEM_DATA && res.SYSTEM_DATA.betting && res.SYSTEM_DATA.betting.length > 0) {
                        this.commit('CURRENT_BETINFO', res.SYSTEM_DATA)
                    }
                    EventBus.$emit('clearBetFormTimer')
                }
            } else {
                this.commit('BETTING_MESSAGE', null)

                // check if parlay has same event selected / has rb and early selected
                if(this.getters.isParlay){
                    var rbBetTypes = ['8','9','10','11','13','16','17','18','20','27','29','31','33','35','37','39','41','43','45','47','49','51','55','56','58','61','64','66','69','71','73','75','78','79','81','83']

                    if(res.SYSTEM_DATA.betting.length > 1){
                        _.forEach(res.SYSTEM_DATA.betting, function(data, index) {
                            if(data.eveid){
                                //check if the bet form has same event 
                                if (firstOccurrencesEvent[data.eveid] === undefined) {
                                    firstOccurrencesEvent[data.eveid] = index;
                                } else {
                                    if(!duplicateEventIndexes.includes(firstOccurrencesEvent[data.eveid])){
                                    duplicateEventIndexes.push(firstOccurrencesEvent[data.eveid]);
                                    }
                                    duplicateEventIndexes.push(index);
                                }

                                if(vue.getters.currentTab != '4') {
                                    var DateNow = new moment().utcOffset("-04:00").startOf('day').unix()
                                    var DateTomorrow = new moment().utcOffset("-04:00").add(1, 'days').startOf('day').unix()
                                    if(window.allowRbParlay) {
                                        if(rbBetTypes.includes(data.betType.toString())){
                                            rbEventExist = true;
                                            // check if rb end date end in next day, allow cross
                                            if(DateNow == data.event_date_timestamp && DateTomorrow == data.event_end_timestamp) {
                                                allowRBCross = true;
                                            }
                                            if(allowRBCross) {
                                                if(!earlyMoreThanOneDay) { // if has early event date diff more than one day with today
                                                    rbEventExist = false;
                                                } else {
                                                    rbEventExist = true;
                                                }
                                            }
                                        } 

                                        if(DateNow < data.event_date_timestamp){
                                            hasEarly = true;
                                            // check if has early event date diff more than one day with today
                                            if(((data.event_date_timestamp - DateNow) / (60 * 60 * 24)) > 1) {
                                                earlyMoreThanOneDay = true;
                                            }
                                            if(allowRBCross) {
                                                if(!earlyMoreThanOneDay) {
                                                    rbEventExist = false;
                                                } else {
                                                    rbEventExist = true;
                                                }
                                            }
                                            if(rbEventExist == true){
                                                crossNotAllow = true;
                                            }
                                        } else if(rbEventExist == true && hasEarly == true){
                                            crossNotAllow = true;
                                        }
                                    } else {
                                        // crossNotAllow = false;
                                        // if(rbBetTypes.includes(data.betType.toString())){
                                        //   crossNotAllow = true;
                                        // }
                                        if(rbBetTypes.includes(data.betType.toString())){
                                            removeArr.push(index)
                                        }
                                    }

                                    if(crossNotAllow) {
                                        if(!earlyEventIndexes.includes(index)) {
                                        earlyEventIndexes.push(index);
                                        }
                                    }
                                }
                            }
                        });
                    } else if(!window.allowRbParlay && res.SYSTEM_DATA.betting.length == 1) {
                        if(rbBetTypes.includes(res.SYSTEM_DATA.betting[0].betType.toString())){
                            duplicateEventIndexes.push(0);
                        }
                    }

                    if(removeArr && removeArr.length > 0){
                        if(removeArr.includes(res.SYSTEM_DATA.betting.length-1)) {
                            this.commit('NOT_SUPPORT_PARLAY', {
                                show: true,
                                msg: this.getters.arr_lang.betForm['BET_FORM.PARLAY_UNSUPPORTED']
                            })
                            setTimeout(function(){
                                vue.commit('NOT_SUPPORT_PARLAY', {reset:true})
                            },1500)
                        }

                        removeArr = removeArr.sort().reverse()
                        $.each(removeArr,function(id,value){
                            vue.commit('BETTING_SELECTION', {
                                isRemove: true,
                                removeIndex: value
                            })
                        });
                    }

                    if(earlyEventIndexes && earlyEventIndexes.length>0){
                        earlyEventIndexes.forEach((value, id) => {
                            if(!duplicateEventIndexes.includes(value)){
                                duplicateEventIndexes.push(value);
                            }
                        });
                    }

                    if(duplicateEventIndexes.length>0){
                        duplicateEventIndexes.forEach((value, id) => {
                            if(res.SYSTEM_DATA.betting[value].error == undefined || res.SYSTEM_DATA.betting[value].error==''){
                                var msg = vue.getters.arr_lang.betForm['BET_FORM.MSG_NOT_SUPPORT_PARLAY'] // "Red selections can't support parlay"
                                var err = {code:"N-4000", message:msg}
                                res.SYSTEM_DATA.betting[value].error = err
                                res.SYSTEM_DATA.code = 'N-4000'
                                res.SYSTEM_DATA.message = msg
                                var currBetInfo = vue.getters.currentBetInfo
                                currBetInfo['betting'] = res.SYSTEM_DATA.betting
                                vue.commit('CURRENT_BETINFO', currBetInfo)
                                vue.commit('BETTING_MESSAGE', {
                                    isError: true,
                                    data: res.SYSTEM_DATA
                                })
                            }
                        });
                    }
                    
                }

                if(this.getters.bettingMessage && this.getters.bettingMessage.isError){
                    this.commit('LATEST_INFO', null)
                    EventBus.$emit('clearBetFormTimer')
                } else {
                    this.commit('LATEST_INFO', res.SYSTEM_DATA)
                    this.commit('CURRENT_BETINFO', res.SYSTEM_DATA)
                }
                // if(this.getters.currentBetInfo==null || this.getters.currentBetInfo == ''){
                //     this.commit('CURRENT_BETINFO', res.SYSTEM_DATA)
                // }else if(this.getters.currentBetInfo!=null && this.getters.currentBetInfo != ''){
                //     if(res.SYSTEM_DATA.betting[0].eveid!=this.getters.currentBetInfo.betting[0].eveid){
                //         this.commit('CURRENT_BETINFO', res.SYSTEM_DATA)
                //     }
                // }
                if (res.SYSTEM_DATA.allUpList) {
                    this.commit('MULP_ALLUP_LIST', res.SYSTEM_DATA.allUpList)
                    // if( !_.find(res.SYSTEM_DATA.allUpList, { 'key': this.getters.selectedAllUp}) )  {
                    //     this.commit('SELECTED_ALLUP', res.SYSTEM_DATA.allUpList[0]['key'])
                    // }

                    var mulpMaxPayArrTemp = []
                    _.forEach(res.SYSTEM_DATA.allUpList, function(value, i) {
                        // cal maxpay
                        var maxpay = 0;
                        if(res.SYSTEM_DATA.minMax && res.SYSTEM_DATA.minMax.max){
                            if(res.SYSTEM_DATA.minMax.maxPay){
                                var mulpParser = value.parser.split("#");
                                for (let index = 0; index < mulpParser.length; index++) {
                                    var ttlOdds = 1;
                                    const commaList = mulpParser[index].split(",");
                                    for (let comma = 0; comma < commaList.length; comma++) {
                                        const betData = res.SYSTEM_DATA.betting[commaList[comma]];
                                        var betOdd = parseFloat(betData.odd);
                                        if(vue.getters.account.oddsType=='am'){
                                            if(betOdd<0){
                                                betOdd=Math.abs(100/betOdd)+1;
                                            }else{
                                                betOdd= (betOdd / 100)+1;
                                            }
                                            betOdd= betOdd.toFixed(3);
                                        }
                                        ttlOdds *= betOdd;
                                    }
                                    maxpay += res.SYSTEM_DATA.minMax.maxPay/ttlOdds;
                                } 
                            }
                            if(res.SYSTEM_DATA.minMax.max > maxpay){
                                mulpMaxPayArrTemp.push(res.SYSTEM_DATA.minMax.max.toFixed(0))
                            } else {
                                mulpMaxPayArrTemp.push(maxpay.toFixed(0))
                            }
                        }
                    })
                    this.commit("MULP_MAX_PAY_ARR", mulpMaxPayArrTemp);

                    if(this.getters.mulpAllUpList.length != this.getters.betMulpAmount.length){
                        var data = []
                        for (let i = 0; i < this.getters.mulpAllUpList.length; i++) {
                            data[i] = ''
                        }
                        this.commit("BETMULP_AMOUNT", data);
                    }
                }
            }
            
            if(payload.callback) {
                return payload.callback(res)
            }
        }).bind(this)).catch((errRes) => {
            console.log(errRes)
        })
    },
    getMulpLatestInfo(context, payload) {
        //mulp
        state.isMulpDayExceed = false
        if (this.getters.arr_selectedTemplate.subTemplateId == 2) {
            var smallDate = null
            var bigDate = null
            _.forEach(this.getters.bettingSelection, ((value) => {
                var onlyDate = new moment(value.event.dt).format('YYYY-MM-DD 00:00:00')
                var eventDate = new moment(onlyDate)
                if (smallDate == null && bigDate == null) {
                    smallDate = eventDate
                    bigDate = eventDate
                }
                //smallDate > eventDate
                if (smallDate.diff(eventDate, 'days') > 0) {
                    smallDate = eventDate
                } else if (eventDate.diff(bigDate, 'days') > 0) {
                    bigDate = eventDate
                }

                if (bigDate.diff(smallDate, 'days') >= 7) {
                    state.isMulpDayExceed = true
                    this.jsError = {
                        error: true,
                        msg: this.arr_lang.betForm['BET_FORM.MSG_EXCEED_PARLAY_DATE']
                    }
                }
            }).bind(this))
        }
        // if (!state.selectedAllUp) {
        //     this.commit('SELECTED_ALLUP', state.latestInfo.allUpList[0]['key'])
        // }
        return state.latestInfo
    },
}

// mutations
const mutations = {
    BETTINGFORM_TOGGLE(state, payload) {
        state.bettingFormToggle = payload
    },
    BETTING_SELECTION(state, payload) {
        
        var bts = {
            selection: state.currentBettingSelectionTemplate,
            tempId: this.getters.arr_selectedTemplate.templateId,
            isOtr: this.getters.isOtr,
            isParlay: this.getters.isParlay,
            isCombo: this.getters.isComboBet,
        }
        
        if(payload.isRemove) {
            state.bettingSelection.splice(payload.removeIndex, 1)
            if(this.getters.currentBetInfo && this.getters.currentBetInfo.betting && this.getters.currentBetInfo.betting.length > 0) {
                this.getters.currentBetInfo.betting.splice(payload.removeIndex, 1)
            }
            bts.data = state.bettingSelection
            localStorage.setItem("bts", JSON.stringify(bts));
            updateHightlightOdds(state.bettingSelection)
            // EventBus.$emit('cBetSlip')
            return
        }
        if(payload.isOffCombo){
            // state.bettingSelection.slice(0, (state.bettingSelection.length-1))
            state.bettingSelection.splice(0, (state.bettingSelection.length-1))
            bts.data = state.bettingSelection
            localStorage.setItem("bts", JSON.stringify(bts));
            updateHightlightOdds(state.bettingSelection)
            // EventBus.$emit('cBetSlip')
            return
        }
        updateHightlightOdds(state.bettingSelection)
        // EventBus.$emit('cBetSlip')
        if (payload.length == 0) {
            state.bettingSelection = payload
            state.combtAmt[0] = 0
            state.mulpAllUpList = null
            state.selectedAllUp = null
            bts.data = state.bettingSelection
            localStorage.setItem("bts", JSON.stringify(bts));
            updateHightlightOdds(state.bettingSelection)
            // EventBus.$emit('cBetSlip')
            return
        }
        if (!this.getters.isParlay && !this.getters.isComboBet) { //this.getters.arr_selectedTemplate.subTemplateId != 2
            //normal match
            var index = _.findIndex(this.getters.bettingSelection, { 'event': { 'eveid': payload.event.eveid } });
            if (index >= 0) { // add for remove same click
                if(state.bettingSelection[index].team==payload.team){
                    state.bettingSelection.splice(index, 1)
                    bts.data = state.bettingSelection
                    localStorage.setItem("bts", JSON.stringify(bts));
                    updateHightlightOdds(state.bettingSelection)
                    this.commit('BETTINGFORM_TOGGLE', false)
                    return
                }else{
                    state.bettingSelection[0] = payload
                }
            } else {
                state.bettingSelection[0] = payload
            }
            bts.data = state.bettingSelection
            localStorage.setItem("bts", JSON.stringify(bts));
            updateHightlightOdds(state.bettingSelection)
            // EventBus.$emit('cBetSlip')
            return
        }

        if (state.bettingSelection.length > 0) {
            if (state.bettingSelection[0]['sportid'] != payload.sportid) {
                state.bettingSelection = []
            }

        }

        if(this.getters.isComboBet){
            var index = _.findIndex(this.getters.bettingSelection, { 'event': { 'eveid': payload.event.eveid}, 'playtype': payload.playtype, 'bettype': payload.bettype, 'subMatchKey': payload.subMatchKey });
            if (index >= 0) {
                if(state.bettingSelection[index].team==payload.team){
                    state.bettingSelection.splice(index, 1)
                    state.combtAmt.splice(index, 1)
                    bts.data = state.bettingSelection
                    localStorage.setItem("bts", JSON.stringify(bts));
                    updateHightlightOdds(state.bettingSelection)
                    return
                }else{
                    state.bettingSelection[index] = payload
                }
            } else {
                payload = [payload]
                state.bettingSelection = state.bettingSelection.concat(payload)
                state.combtAmt = state.combtAmt.concat(0)
            }
        }else{
            var index = _.findIndex(this.getters.bettingSelection, { 'event': { 'eveid': payload.event.eveid } });
            if (index >= 0) {
                if(state.bettingSelection[index].team==payload.team){
                    state.bettingSelection.splice(index, 1)
                    bts.data = state.bettingSelection
                    localStorage.setItem("bts", JSON.stringify(bts));
                    updateHightlightOdds(state.bettingSelection)
                    this.commit('BETTINGFORM_TOGGLE', false)

                    if(this.getters.isParlay && this.getters.currentTab != '4' && state.bettingSelection.length == 0) {
                        this.commit('IS_PARLAY', false)
                    }
                    return
                }else{
                    state.bettingSelection[index] = payload
                }
            } else {
                payload = [payload]
                state.bettingSelection = state.bettingSelection.concat(payload)
            }
        }
        
        bts.data = state.bettingSelection
        localStorage.setItem("bts", JSON.stringify(bts));
        updateHightlightOdds(state.bettingSelection)
        // EventBus.$emit('cBetSlip')
    },
    LATEST_INFO(state, payload) {
        if (payload) {
            if (_.isUndefined(payload.minMax) || payload.minMax == null) {
                payload.minMax = this.getters.latestInfo.minMax
            }
            if (state.latestInfo && payload.betting) {
                var keyList = [ 'dual', 'fav', 'hdp', 'hdpCap', 'odd', 'rbscoa', 'rbscob' ]

                for (let index = 0; index < payload.betting.length; index++) {
                    const element = payload.betting[index];
                    keyList.forEach(value => {
                        var oldBettingIndex = _.findIndex(state.latestInfo.betting, {
                            eveid: payload.betting[index].eveid
                        })
                        if(oldBettingIndex < 0)
                            return;
                        
                        payload.betting[index][value + 'Chg'] = false
                        if (value == 'odd' || value == 'hdp') {
                            if (parseFloat(state.latestInfo.betting[oldBettingIndex][value]) != parseFloat(payload.betting[index][value])) {
                                payload.betting[index][value + 'Chg'] = true
                            }
                        } else {
                            if (state.latestInfo.betting[oldBettingIndex][value] !== payload.betting[index][value]) {
                                payload.betting[index][value + 'Chg'] = true
                            }
                        }
                    })
                }
            }

        }
        state.latestInfo = payload
    },
    BETTING_MESSAGE(state, payload) {
        state.bettingMessage = payload
    },
    MULP_ALLUP_LIST(state, payload) {
        state.mulpAllUpList = payload
    },
    SELECTED_ALLUP(state, payload) {
        state.selectedAllUp = payload
    },

    BETTING_DELAY_TIMERID(state, payload) {
        if (state.delayBetTimerId) {
            this.commit('REQUEST_ALLOW', true)
            clearTimeout(state.delayBetTimerId)
        }
        state.delayBetTimerId = payload
    },
    BETAMOUNT(state, payload) {
        state.betAmount = payload
    },
    SHOWDELBTN(state, payload) {
        state.showDelAll = payload
    },
    COMMONAMT_SETTING(state, payload) {
        state.commonAmtSetting = payload
    },
    COMMONAMT(state, payload) {
        state.commonAmt = payload
    },
    POSSIBLEAMT(state, payload) {
        state.possibleAmt = payload
    },
    SHOWHELP(state, payload) {
        state.showHelp = payload
    },
    TIPS_TYPE(state, payload) {
        state.tipsType = payload
    },
    CURRENT_BETINFO(state, payload) {
        state.currentBetInfo = payload
    },
    BETTING_ALLUP (state, payload) {
        if(payload) {
            state.betting.selectedBetAllup = payload
        }
    },
    EMPTY_BETAMT_STATUS (state, payload){
        state.emptyBetAmt = payload
    },
    IS_COMBOBET (state, payload) {
        state.isComboBet = payload
    },
    COMBET_AMT(state, payload){
        state.combtAmt = payload
    },
    COMB_MAX(state, payload){
        state.combMaxInfo = payload
    },
    SELECTED_COMBOX(state, payload){
        state.selectedCombtBox = payload
    },
    COMB_SUCCESS_BET_LIST(state, payload){
        state.comboSuccessBetList = payload
    },
    SUCCESS_BETTING_SELECTION(state, payload){
        state.successBettingSelection = payload
    },
    CURRENT_BET_MARKET(state, payload){
        state.currentBetMarket = payload
    },
    KEEP_BETTING_SELECTION(state, payload){
        state.keepBettingSelection = payload
    },
    COMB_ERR_BET_LIST(state, payload){
        state.comboErrBetList = payload
    },
    ERR_BETTING_SELECTION(state, payload){
        state.errorBettingSelection = payload
    },
    HAV_EMPTY_COMBO(state, payload){
        state.haveEmptyCombo = payload
    },
    COMBO_REACH_MAXBET(state, payload){
        state.comboReachMaxBet = payload
    },
    IS_SHOW_CHIPMIN(state, payload){
        state.isShowChipMin = payload
    },
    IS_SHOW_CHIPMED(state, payload){
        state.isShowChipMed = payload
    },
    IS_SHOW_CHIPBIG(state, payload){
        state.isShowChipBig = payload
    },
    BETMULP_AMOUNT(state, payload){
        state.betMulpAmount = payload
    },
    BETMULP_AMOUNT_FILTERED(state, payload){
        state.betMulpAmtFiltered = payload
    },
    NOT_SUPPORT_PARLAY(state, payload){
        if(payload.reset){
            state.notSupportParlay = {show:false}
        } else {
            state.notSupportParlay = payload
        }
    },
    PREV_COMBOBET(state, payload){
        state.prev_combobet = payload
    },
    MULP_MAX_PAY_ARR(state, payload){
        state.mulpMaxPayArr = payload
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./resources/score/vue/store/modules/betting-form.js